module.exports = __webpack_public_path__ + "nc_static/media/quality rep.82510a1d.svg";